module.exports = __webpack_public_path__ + "img/ah11.fdc43649.jpg";